// eslint-disable-next-line @typescript-eslint/no-unused-vars

import { Form, NavLink } from "react-router";
import { FaQuestion, FaSignOutAlt } from "react-icons/fa";
import { type UserDetails } from "~/models/UserDetails";

export default function Header({
  userDetails,
}: {
  userDetails: UserDetails | null;
}) {
  if (!userDetails) {
    return null;
  }

  return (
    <div className="flex items-center justify-center gap-4">
      <NavLink
        to="/people"
        className={({ isActive, isPending }) =>
          isPending
            ? "nav-item pending"
            : isActive
              ? "nav-item active"
              : "nav-item"
        }
      >
        People
      </NavLink>
      <NavLink
        to="/groups"
        className={({ isActive, isPending }) =>
          isPending
            ? "nav-item pending"
            : isActive
              ? "nav-item active"
              : "nav-item"
        }
      >
        Groups
      </NavLink>
      <NavLink
        to="/events"
        className={({ isActive, isPending }) =>
          isPending
            ? "nav-item pending"
            : isActive
              ? "nav-item active"
              : "nav-item"
        }
      >
        Events
      </NavLink>

      <NavLink
        to="/help"
        className={({ isActive, isPending }) =>
          isPending
            ? "nav-item pending"
            : isActive
              ? "nav-item active"
              : "nav-item"
        }
      >
        <FaQuestion />
      </NavLink>

      <Form method="post">
        <button
          type="submit"
          className="nav-item flex items-center"
          aria-label="Log out"
          name="subaction"
          value="logout"
          title="Log out"
        >
          <FaSignOutAlt className="" />
        </button>
      </Form>
    </div>
  );
}
